import { buildValueMap } from "./utils";

export const ItemTypeDef = {
    Inventory: { value: 1, label: "Inventory Item" },
    NonInventory: { value: 2, label: "Non-Inventory Item" }
};

export const ItemSafetyStockTypeDef = {
    None: { value: 0, label: "None" },
    Days: { value: 1, label: "Days" },
    UOM: { value: 2, label: "UOM" }
};

export const InventoryAdjustmentTypeDef = {
    Receipt: { value: 1, label: "Receipt" },
    ReceiptCancel: { value: 2, label: "Cancel Receipt" },
    Pick: { value: 3, label: "Pick" },
    PickCancel: { value: 4, label: "Cancel Pick" },
    Fulfillment: { value: 5, label: "Fulfillment" },
    FulfillmentCancel: { value: 6, label: "Cancel Fulfillment" },
    Adjust: { value: 7, label: "Inventory Adjustment" },
    Count: { value: 8, label: "Inventory Count" },
    Return: { value: 9, label: "Return" },
    Transfer: { value: 10, label: "Inventory Transfer" }
};

export const InventoryReferenceTypeDef = {
    Receipt: { value: 1, label: "Receipt" },
    PickOrder: { value: 2, label: "Pick Order" },
    Fulfillment: { value: 3, label: "Fulfillment" },
    Adjustment: { value: 4, label: "Inventory Adjustment" },
    Count: { value: 5, label: "Inventory Count" },
    Return: { value: 6, label: "Return" }
};

export const InvAdjustmentOrderTypeDef = {
    Adjustment: { value: 1, label: "Inventory Adjustment" },
    NewInventory: { value: 2, label: "New Inventory" }
};

export const ItemType = buildValueMap(ItemTypeDef);
export const ItemSafetyStockType = buildValueMap(ItemSafetyStockTypeDef);
export const InventoryAdjustmentType = buildValueMap(InventoryAdjustmentTypeDef);
export const InventoryReferenceType = buildValueMap(InventoryReferenceTypeDef);
export const InvAdjustmentOrderType = buildValueMap(InvAdjustmentOrderTypeDef);
